import { render, staticRenderFns } from "./RouteSelector.vue?vue&type=template&id=59235499&scoped=true&"
import script from "./RouteSelector.vue?vue&type=script&lang=js&"
export * from "./RouteSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59235499",
  null
  
)

export default component.exports